<div *ngIf="!metricsUrl" class="text-center">
  <div class="spacer spacer--4"></div>
  <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
  <div class="spacer spacer--4"></div>
</div>

<div
  #chartioIFrame
  class="chartio-wrapper"
  [ngStyle]="{ 'height.px': chartioHeight }"
>
  <iframe
    *ngIf="metricsUrl"
    [src]="metricsUrl"
    frameborder="0"
    [height]="chartioHeight"
  >
    <p>Browser does not Support iFrames</p>
  </iframe>
</div>
<div id="chartio-iframe-target"></div>
<nz-back-top></nz-back-top>
